/**
 * Comunicação com a Edge Function billing-info (dados Stripe da org atual).
 */
import { getValidAccessToken } from '../../../lib/supabase';

export interface StripeBillingInfo {
    subscription: {
        status: string;
        planName: string;
        quantity: number;
        currentPeriodEnd: string | null;
        trialEnd: string | null;
        isTrialing: boolean;
        cancelAtPeriodEnd: boolean;
        pricePerUnit: number;
        currency: string;
    } | null;
    upcomingInvoice: {
        amountDue: number;
        currency: string;
        dueDate: string | null;
    } | null;
    latestInvoice: {
        id: string;
        number: string | null;
        amountPaid: number;
        currency: string;
        status: string;
        paidAt: string | null;
        hostedInvoiceUrl: string | null;
        invoicePdf: string | null;
    } | null;
    invoiceHistory: Array<{
        id: string;
        number: string | null;
        amountPaid: number;
        currency: string;
        status: string;
        paidAt: string | null;
        hostedInvoiceUrl: string | null;
        invoicePdf: string | null;
    }>;
    paymentMethod: {
        type: string;
        brand: string | null;
        last4: string | null;
        expMonth: number | null;
        expYear: number | null;
    } | null;
    customer: {
        email: string | null;
        name: string | null;
        address: {
            line1: string | null;
            line2: string | null;
            city: string | null;
            state: string | null;
            postal_code: string | null;
            country: string | null;
        } | null;
    } | null;
}

export async function fetchBillingInfo(organizationId: string): Promise<StripeBillingInfo> {
    const accessToken = await getValidAccessToken();

    const url = new URL(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/billing-info`);
    url.searchParams.set('organizationId', organizationId);

    const response = await fetch(url.toString(), {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
        },
    });

    if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        throw new Error(err.error || 'Falha ao buscar dados de billing');
    }

    return response.json();
}
